module.exports = __webpack_public_path__ + "static/media/LoginBackground.92842f7b.png";